import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import { providersEnglishNames } from '../constants';

const englishSourceNames = Object.values(providersEnglishNames);

export interface ISource {
  _id: ObjectID;
  name: string;
  url: string;
  user: ObjectID;
  createdAt: Date;
  updatedAt: Date;
}

export interface ISourceDocument extends mongoose.Document, ISource {
  _id: ObjectID;
}

const source = new Schema(
  {
    name: {
      type: String,
      required: true,
      enum: englishSourceNames,
    },
    url: {
      type: String,
      required: true,
    },
    user: {
      type: Schema.Types.ObjectId,
      ref: 'User',
    },
  },
  { timestamps: true },
);

export default source;
